import cn from 'classnames';

type Props = {
  onClickMore: () => void;
  text: string;
  show: boolean;
  direction: 'down' | 'right';
};

const More = ({onClickMore, text, show, direction}: Props) => {
  if (!show) {
    return null;
  }

  return (
    <button type="button" className="btn_more" onClick={onClickMore}>
      {text}
      <span
        className={cn('icon', {
          icon_arr_down_type5: direction === 'down',
          icon_arr_right_type7: direction === 'right'
        })}
      />
    </button>
  );
};

export default More;
